import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { copilotMessagePublisherEnvironment } from '../copilot-message-publisher-environment';
import { MessageToPublish } from '../models/message-to-publish';

/**
 * Sends a CoPilot Request Action with multiple messages
 * @param messages An array of messages to send
 * @returns An object indicating success
 */
export function postPublishBulk(this: unknown, messages: MessageToPublish[]) {
  return fromFetch(
    new Request(
      copilotMessagePublisherEnvironment.resolve(this).publishBulkUrl,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(messages),
      }
    )
  ).pipe(
    selectData(
      z.object({
        success: z.literal(true),
      })
    )
  );
}
